import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import loginImg from "../assets/images/login-img.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { isEmpty } from "lodash";
import { Helmet } from "react-helmet";
import { isMobile } from "react-device-detect";
const Login = () => {
  const navigate = useNavigate();
  let { loginUser, user } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    unregister,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const [showPassword, setShowPassword] = useState(true);
  const onSubmit = (data) => {
    loginUser(data);
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      navigate("/");
    }
  }, [user]);
  const [getValidateCode, setValidateCode] = useState("");
  const canvasRef = useRef(null);
  const changeCode = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.font = "bold 120px sans-serif";
    const code = Math.floor(1000 + Math.random() * 9000);
    context.clearRect(0, 0, canvas.width, canvas.height);
    // Background color
    context.fillStyle = "#9D1805"; // Light blue
    context.fillRect(0, 0, canvas.width, canvas.height);
    // Text color
    context.fillStyle = "#fff";

    context.fillText(code, 10, 130);
    setValidateCode(code);
  };

  useEffect(() => {
    changeCode();
  }, []);
  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex justify-content-center align-items-center w-100 login-main-new"
    >
      {" "}
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no"
        />
      </Helmet>
      <Container className="h-100 align-middle">
        <Row
          className="h-100 align-items-center align-middle justify-content-center d-flex"
          style={
            isMobile ? { flexDirection: "column" } : { flexDirection: "row" }
          }
        >
          {" "}
          <div
            style={{
              background: "#104532",
              padding: "5px",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "70%",
              marginBottom: "10px",
            }}
          >
            <img src="./assets/images/logo.png" style={{ width: "160px" }} />
          </div>{" "}
          
          
          {!isMobile && (
            <Col md={7} className="text-start">
              <img
                data-aos="zoom-in-down"
                src={loginImg}
                style={{ width: "80%" }}
              />
            </Col>
          )}
          <Col md={5}>
            <div data-aos="flip-up" className="text-center mb-4">
              <img
                src={require("../assets/images/agentlogin.png")}
                style={{ width: "200px" }}
              />
            </div>
            <Form
              style={{
                padding: "10px 20px",
                borderRadius: "5px",
                border: "3px solid #52783B",
              }}
              onSubmit={handleSubmit(onSubmit)}
            >
              <div class="form-group">
                <label
                  style={{
                    marginBottom: "5px",
                    color: "white",
                    fontWeight: "600",
                  }}
                  for="email"
                >
                  User Name
                </label>
                <Form.Group className="mb-2">
                  <Form.Control
                    style={{ borderRadius: "6px" }}
                    type="text"
                    placeholder="Username"
                    className={errors.username ? "is-invalid" : ""}
                    {...register("username", {
                      required: "Please enter Username",
                    })}
                  />
                  {errors.username && errors.username.message && (
                    <label className="invalid-feedback text-left">
                      {errors.username.message}
                    </label>
                  )}
                </Form.Group>
              </div>
              <div class="form-group">
                <label
                  style={{
                    marginBottom: "5px",
                    color: "white",
                    fontWeight: "600",
                  }}
                  for="pwd"
                >
                  Password:
                </label>

                <Form.Group className="mb-2 position-relative">
                  <Form.Control
                    style={{ borderRadius: "6px" }}
                    type={!showPassword ? "text" : "password"}
                    placeholder="Password"
                    maxLength={15}
                    {...register("password", {
                      required: "Please enter password",
                    })}
                    className={errors.password ? "is-invalid" : ""}
                  />
                  <Button
                    className="position-absolute translate-middle-y top-50 end-0 me-2 bg-transparent border-0 text-dark p-0 "
                    onClick={() => handleShow()}
                  >
                    {!showPassword ? (
                      <FaEye className="opacity-100 fs-5" size="17" />
                    ) : (
                      <FaEyeSlash className="opacity-100 fs-5" size="17" />
                    )}
                  </Button>
                  {errors.password && errors.password.message && (
                    <label className="invalid-feedback text-left">
                      {errors.password.message}
                    </label>
                  )}
                </Form.Group>
              </div>

              <Form.Group style={{ position: "relative" }} className="mb-2">
                <Form.Control
                  type="text"
                  placeholder="Enter Captcha"
                  style={{
                    borderRadius: "8px",
                    paddingRight: "130px",
                    height: "45px",
                  }}
                  className={errors.validateCode ? "is-invalid" : ""}
                  {...register("validateCode", {
                    required: "Please enter validate code",
                    validate: (value) =>
                      Number(value) === Number(getValidateCode) ||
                      "Invalid validate code",
                  })}
                />

                <canvas
                  ref={canvasRef}
                  onClick={changeCode}
                  id="authenticateImage"
                  style={{
                    position: "absolute",
                    right: "5px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "110px",
                    height: "35px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    background: "#fff",
                  }}
                />


              </Form.Group>
              {errors.validateCode && (
                <div className="invalid-feedback d-block">
                  {errors.validateCode.message}
                </div>
              )}
              <div>
                <button
                  type="submit"
                  tabindex="3"
                  style={{
                    backgroundImage: "linear-gradient(#022c43, #12243c)",
                    color: "white",
                    width: "100%",
                    padding: "8px",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: "600",
                  }}
                  class="text-center login-bt"
                >
                  LOGIN
                </button>
              </div>
            </Form>

            <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', marginTop: "5px" }}>
              <img style={{ width: "40px", marginRight: "5px" }}
                src={require("../assets/images/WhatsApp_Image_2026-05-31_at_12.27.59_PM-removebg-preview.png")}
              />{" "}
              <img style={{ width: "40px" }}
                src={require("../assets/images/WhatsApp_Image_2026_05_31_at_12_27_59_PM_1_removebg_preview_1.png")}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
